var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prize-card",class:_vm.setLayoutColor},[_c('div',{staticClass:"prize-card__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"prize-card__image"},[_c('img',{attrs:{"src":_vm.image}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }